/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Mode_HintInputs */



/**
* | output |
* | --- |
* | "Have a hands-free, spoken back-and-forth conversation with the assistant — it listens and replies out loud." |
*
* @param {Voice_Mode_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const voice_mode_hint = /** @type {((inputs?: Voice_Mode_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Mode_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Führe eine freihändige, gesprochene Unterhaltung mit dem Assistenten – er hört zu und antwortet laut.")
	return /** @type {LocalizedString} */ ("Have a hands-free, spoken back-and-forth conversation with the assistant — it listens and replies out loud.")
});